import { ChangeEvent } from 'react';

import {
  CURRENCY_SYMBOLS,
  DEFAULT_CURRENCY,
  type PaymentCurrency,
} from '@/config/currency';

import styles from './InputPrice.module.css';

interface IInputProps {
  name: string;
  className?: string;
  value: string;
  placeholder?: string;
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  handleClick?: () => void;
  disabled?: boolean;
  /** TourOffer source currency — display symbol only; no conversion. */
  currency?: PaymentCurrency;
}

export const InputPrice = ({
  name,
  className = '',
  value,
  placeholder = 'Type here...',
  handleChange,
  handleClick = () => {},
  disabled = false,
  currency = DEFAULT_CURRENCY,
}: IInputProps) => {
  const symbol = CURRENCY_SYMBOLS[currency] ?? CURRENCY_SYMBOLS[DEFAULT_CURRENCY];
  const numValue = (value || '').replace(/\D/g, '');
  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const digits = e.target.value.replace(/\D/g, '');
    handleChange({ ...e, target: { ...e.target, value: digits } } as ChangeEvent<HTMLInputElement>);
  };

  return (
    <div
      className={`flex items-center border border-gray-700 rounded overflow-hidden min-w-[5.5rem] ${className}`}
    >
      <span className="text-gray-400 text-sm pl-2 pr-1 shrink-0" aria-hidden>
        {symbol}
      </span>
      <input
        type="text"
        name={name}
        value={numValue}
        onChange={handleInputChange}
        placeholder={placeholder.replace(/^[^\d\s]*\s*/, '')}
        className={`flex-1 min-w-[5ch] pl-1 pr-2 py-2 border-0 text-white text-sm focus:outline-none focus:ring-0 ${styles.priceInput}`}
        onClick={handleClick}
        disabled={disabled}
        inputMode="numeric"
        aria-label={`Price in ${currency}`}
      />
    </div>
  );
};
